import { apiFetch } from './client';

export interface DashboardVertical {
  id: number;
  name: string;
  slug: string;
}

export interface DashboardStage {
  stage: string;
  count: number;
  value_minor: number;
}

export interface DashboardPipeline {
  currency?: string;
  by_currency?: { currency: string; total_minor: number; deal_count: number }[];
  total_minor: number;
  delta_month_minor: number | null;
  deal_count: number;
  trend: (number | null)[];
  by_stage: DashboardStage[];
}

export interface DashboardLeadSource {
  source: string;
  pct: number;
}

export interface DashboardLeads {
  new_this_week: number;
  delta_vs_last_week: number;
  weekly_inflow: number[];
  total_8w: number;
  pct_vs_prior_8w: number | null;
  by_source: DashboardLeadSource[];
}

export interface DashboardWinRate {
  quarter_pct: number | null;
  delta_pts: number | null;
  trend: (number | null)[];
}

export interface DashboardOldestIssue {
  id: number;
  title: string;
  created_at: string;
}

export interface DashboardIssues {
  open: number;
  in_progress: number;
  resolved_week: number;
  total: number;
  oldest_open: DashboardOldestIssue | null;
}

export type AttentionType = 'lead_untouched' | 'issue_unassigned' | 'deal_stale' | 'activity_overdue';
export type AttentionSeverity = 'high' | 'medium' | 'low';
export type AttentionTargetView = 'leads' | 'issues' | 'deals' | 'activities';

export interface DashboardAttentionItem {
  type: AttentionType;
  title: string;
  meta: string;
  target_view: AttentionTargetView;
  target_id: number;
  severity: AttentionSeverity;
}

export interface DashboardActivityItem {
  id: number;
  kind: string;
  summary: string;
  created_at: string;
  vertical: string;
}

export interface Dashboard {
  scope: string;
  verticals: DashboardVertical[];
  pipeline: DashboardPipeline;
  leads: DashboardLeads;
  win_rate: DashboardWinRate;
  issues: DashboardIssues;
  attention: DashboardAttentionItem[];
  activity: DashboardActivityItem[];
}

export const dashboardApi = {
  // scope: a vertical id or 'all' — matches the ?vertical=<id|all> contract
  // in internal/api/handlers/dashboard.go 1:1 (admin default 'all', member
  // default their primary vertical, 'all' 403s for non-admins).
  get: (scope: number | 'all') => apiFetch<Dashboard>(`/dashboard?vertical=${scope}`)
};
